import $axios from '~/plugins/axios';

import { Api, GetSettingPosZoneParams, PosZone } from '~/api';
import { buildModule } from '../utils';
import { createDict, Dict, fetchAllPages } from '~/helpers';

const api = $axios as Api;

type LazyLoadingParams = Omit<GetSettingPosZoneParams, 'limit' | 'offset'>;

export default buildModule()
	.withState({
		posZoneById: {} as Dict<PosZone>,
		orderedIds: [] as number[],
		params: {} as LazyLoadingParams,
	})
	.withGetters({
		items: (state) => state.orderedIds.map(id => state.posZoneById[id]),
		byId: (state) => (id: number) => state.posZoneById[id],
	})
	.withMutations({
		RESET (state, params: LazyLoadingParams = {}) {
			state.params = params;
			state.orderedIds = [];
		},
		APPEND_POS_ZONES (state, posZones: PosZone[]) {
			state.posZoneById = { ...state.posZoneById, ...createDict(posZones, ({ id }) => id) };
			state.orderedIds = Array.from(new Set([ ...state.orderedIds, ...posZones.map((posZone) => posZone.id) ]));
		},
		SET_POS_ZONES (state, posZones: PosZone[]) {
			state.posZoneById = { ...state.posZoneById, ...createDict(posZones, ({ id }) => id) };
		},
	})
	.withActions({
		async getMore ({ state, commit }, limit: number) {
			const params: GetSettingPosZoneParams = { ...state.params, limit, offset: state.orderedIds.length };
			const { data } = await api.get('/setting/pos-zone', { params });

			commit('APPEND_POS_ZONES', data.payload);
		},
		async prefetchPosZones ({ commit }, posZoneIds: number[]) {
			const posZoneGetRequests = posZoneIds.map((id) => api.get(`/setting/pos-zone/${ id }`));
			const posZoneResponses = await Promise.all(posZoneGetRequests);

			const posZones = posZoneResponses.map((resp) => resp.data.payload);
			commit('SET_POS_ZONES', posZones);
		},
		async getPosZone ({ commit }, posZoneId: number) {
			const { data } = await api.get(`/setting/pos-zone/${ posZoneId }`);

			commit('SET_POS_ZONES', [ data.payload ]);
		},
		async getAll ({ state, commit }, params: LazyLoadingParams = {}) {
			const allParams: GetSettingPosZoneParams = { ...state.params, ...params };
			const items = await fetchAllPages('/setting/pos-zone', allParams)<PosZone>(api);
			commit('SET_POS_ZONES', items);

			return items;
		},
		resetParams ({ state, commit }, params: LazyLoadingParams = {}) {
			commit('RESET', { ...state.params, ...params });
		},
	});


